$(document).ready(function() {

	// Mobile Menu Logic

	// Open nav
	$('.hamburger').on('click', function(e) {
		e.preventDefault();
		$('.nav-mobile-wrap').addClass('nav-is-open');
	});
	// Close nav
	$('.btn-close-nav').on('click', function(e) {
		e.preventDefault();
		$('.nav-mobile-wrap').removeClass('nav-is-open');
	});

	// Mobile Nav Dropdown logic
	$('.nav-mobile-wrap .dropdown > a').on('click', function(e) {
		e.preventDefault();
		$(this).siblings('ul').slideToggle(400)
		$(this).toggleClass('dropdown-is-open');
	});

	// Remove desktop nav border if the first widget is the slider
	if ($('.widget-slider-primary').hasClass('first-widget')) {
		$('.desktop-nav').css('border-bottom', 'none')
	};

	// Initiating Sliders

	$('.slider.primary-slider').slick({
		pauseOnHover: true,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: false,
		speed: 1500,
		adaptiveHeight: true,
		prevArrow : '<div class="prev-arrow"><i class="fa fa-chevron-left"></i></div>',
		nextArrow : '<div class="next-arrow"><i class="fa fa-chevron-right"></i></div>',
		dots: true,
		arrows: false
	});
	$('.slider.secondary-slider').slick({
		pauseOnHover: true,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: false,
		speed: 500,
		adaptiveHeight: true,
		prevArrow : '<div class="prev-arrow"><i class="fa fa-chevron-left"></i></div>',
		nextArrow : '<div class="next-arrow"><i class="fa fa-chevron-right"></i></div>'
	});
	$('.home-testimonials, .faqs-slider').slick({
		pauseOnHover: true,
		autoplay: true,
		autoplaySpeed: 2000,
		fade: true,
		speed: 100,
		adaptiveHeight: true,
		dots: false,
		arrows: false
	});

	// To make the QTY buttons work

	$(".btn-qty").on("click", function() {
		var $button = $(this);
		var oldValue = $button.parent().find("input").val();

		if ($button.hasClass('inc')) {
			var newVal = parseFloat(oldValue) + 1;
		} else {
			// Don't allow decrementing below one
			if (oldValue > 1) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 1;
			}
		}
		$button.parent().find("input").val(newVal);
	});

	// Product Zoom plugin here
	

	// Account/Customer Logic

	$('.forgot-password').on('click', function(e) {
		e.preventDefault();
		showRecoverPasswordForm();
	});
	$('.recover-password-cancel').on('click', function(e) {
		e.preventDefault();
		hideRecoverPasswordForm();
	});

	function showRecoverPasswordForm() {
		$('#recover-password').css('display', 'block');
		$('#customer').css('display', 'none');
	}

	function hideRecoverPasswordForm() {
		$('#recover-password').css('display', 'none');
		$('#customer').css('display', 'block');
	}

	if (window.location.hash == '#recover') { showRecoverPasswordForm() }

});